import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { cn } from '@/lib/utils'
import { ZygouxuanIcon, ZyjianshaoIcon } from './icon'
interface CheckboxProps extends React.ComponentProps<typeof CheckboxPrimitive.Root> {
  onValueChange?: (checked: boolean) => void
}
function Checkbox({ onValueChange, className, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'group hover:border-accent peer border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-danger/20 dark:aria-invalid:ring-danger/40 aria-invalid:border-danger size-4 shrink-0 rounded-xs border shadow-xs transition-shadow outline-none focus-visible:ring-0.75',
        'data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary',
        'disabled:!cursor-not-allowed disabled:bg-hover disabled:hover:border-input disabled:opacity-100',
        'data-[state=checked]:disabled:bg-hover data-[state=checked]:disabled:border-active',
        className,
      )}
      onCheckedChange={onValueChange}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        {props.checked === 'indeterminate' && <ZyjianshaoIcon className=" bg-accent text-background" />}
        {props.checked === true && <ZygouxuanIcon className=" text-background group-disabled:text-muted-foreground" />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
